import { Gift, Wrench } from 'lucide-react';

// Branded "back soon" screen shown while the site (or a single page) is in
// maintenance mode. Admins never see this, gating happens in App.js.
export default function MaintenancePage({ message, pageOnly = false }) {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: 'linear-gradient(160deg, #FFFBF7 0%, #FED7A5 100%)' }}
      data-testid="maintenance-page"
    >
      <div className="max-w-md text-center">
        <div
          className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
          style={{ background: 'linear-gradient(135deg, #9E6752 0%, #534145 100%)', boxShadow: '0 16px 40px rgba(83,65,69,0.25)' }}
        >
          <Wrench className="w-9 h-9" style={{ color: '#FED7A5' }} />
        </div>
        <p className="text-3xl mb-1" style={{ fontFamily: 'Great Vibes, cursive', color: '#9E6752' }}>Mementa</p>
        <h1 className="text-2xl sm:text-3xl font-bold mb-3" style={{ fontFamily: 'Playfair Display, serif', color: '#20212B' }}>
          {pageOnly ? 'This page is getting a little polish' : "We'll be right back"}
        </h1>
        <p className="text-base leading-relaxed mb-6" style={{ color: '#534145' }}>
          {message || (pageOnly
            ? 'This part of Mementa is briefly down for maintenance. The rest of the site is still open.'
            : "We're doing a quick bit of maintenance to make gift-finding even better. Check back shortly.")}
        </p>
        {pageOnly && (
          <a
            href="/"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-semibold transition-transform hover:scale-105"
            style={{ background: '#9E6752', color: 'white' }}
            data-testid="maintenance-back-home"
          >
            <Gift className="w-4 h-4" /> Back to Browse
          </a>
        )}
      </div>
    </div>
  );
}
